module.exports = __webpack_public_path__ + "img/project-pic4.fa01737e.png";